import { createContext, useState, useEffect } from 'react';

const AccountContext = createContext(null);

const AccountProvider = ({ children }) => {
    const [account, setAccount] = useState((localStorage.getItem("account") && JSON.parse(localStorage.getItem("account"))) || (sessionStorage.getItem("account") && JSON.parse(sessionStorage.getItem("account"))) || null);
       
    useEffect(() => {

        if (account){
            if (account.isRemember){
                localStorage.setItem('account', JSON.stringify(account));
            }
            sessionStorage.setItem('account', JSON.stringify(account));
        }
                
    }, [account])
    return (
        <AccountContext.Provider value={[account, setAccount]}>
            {children}
        </AccountContext.Provider>
    )
}


export { AccountContext, AccountProvider }